import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b1ab59d2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b1ab59d2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ab59d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/data/jenkins/workspace/etower/etower-qa-tracking-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1ab59d2')) {
      api.createRecord('b1ab59d2', component.options)
    } else {
      api.reload('b1ab59d2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b1ab59d2&scoped=true", function () {
      api.rerender('b1ab59d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/login/LangSelect/index.vue"
export default component.exports